import { render, staticRenderFns } from "./confirm_order.vue?vue&type=template&id=fd9cdbf2&"
import script from "./confirm_order.vue?vue&type=script&lang=js&"
export * from "./confirm_order.vue?vue&type=script&lang=js&"
import style0 from "./confirm_order.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports